import axios from 'axios';
const baseURL = "https://myhotchop-api.onrender.com/api/v1";

export default axios.create({ baseURL });
